module.exports = __webpack_public_path__ + "img/Patch_Notes-Hover.aff512c1.webp";